import { mapGetters } from 'vuex'

/*
  This mixin require that component implement a data named loadDocuments that contain the function to load datas.
  A data named sortBy and a data named query. Exemple:
  data () {
   loadDocuments: this.loadPromoteurs,
   sortBy: {
      name: {
        order: null,
        sort: false
      }
   },
   query: {}
  }
 */

export default {
  data () {
    return {
      enabledSaveSort: false,
      loadDocuments: null // Must be function (query = {}, page = 1, perPage = 20)
    }
  },
  computed: {
    ...mapGetters(['currentUserPreferences', 'currentUserPk'])
  },
  methods: {
    sort (by, e) {
      for (const s in this.sortBy) {
        this.$set(this.sortBy, s, {order: null, sort: false})
      }
      this.$set(this.sortBy, by, e)
      this.filters.sort = `${by}:${e.order}`
      this.changeFilters(0)
      if (this.enabledSaveSort) {
        this.saveSortInUserParams()
      }
      // this.loadDocuments()
    },
    saveSortInUserParams () {
      this.currentUserPreferences[`sort-${this.$route.name}`] = this.query.sort
      this.$api.userService.patch(this.currentUserPk, {app_preferences: this.currentUserPreferences})
    }
  },
  created () {
    if (!this.sortBy && typeof this.sortBy !== 'object') {
      console.warn('sortBy must be defined in data and must be an object.')
    }
    if (!this.query && typeof this.query !== 'object') {
      console.warn('query must be defined in data and must be an object.')
    }
    if (!this.loadDocuments && typeof this.loadDocuments !== 'function') {
      console.warn('loadDocuments must be defined in data and must be a function.')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/SortMixin.js